import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { _3_DAYS } from "../../../constants/durations";
import type { EventDatabse } from "../../../types";
import { keys } from "./keys";

async function fetchSubTopicEvents(subTopicId: string): Promise<EventDatabse[]> {
  const { data, error } = await apiClient
    .from('events')
    .select('*')
    .eq('subject_id', subTopicId)
    .order('date', { ascending: true });

  if (error) {
    throw error;
  }

  return data ?? [];
}

export function useGetSubTopicEvents(subTopicId: string | undefined) {
  return useQuery({
    queryKey: keys.bySubTopicId(subTopicId ?? ''),
    queryFn: () => fetchSubTopicEvents(subTopicId!),
    enabled: !!subTopicId,
    staleTime: _3_DAYS,
  });
}
